import { SERVER_API_URL } from "../app.constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class WorkplaceService {
    private resourceUrl = SERVER_API_URL + 'api/workplaces';

    constructor(
        private http: HttpClient) {
    }

    getWorkplaces(includeInactive = false): Observable<HttpResponse<Nema.Crew.Model.Workplace[]>> {
        return this.http
            .get<Nema.Crew.Model.Workplace[]>(`${this.resourceUrl}?includeInactive=${includeInactive}`, { observe: 'response' })
            .map((res: HttpResponse<Nema.Crew.Model.Workplace[]>) => this.convertArrayResponse(res));
    }

    //private _convertResponse(res: HttpResponse<WorkplaceDto>): HttpResponse<WorkplaceDto> {
    //    const body: WorkplaceDto = this.convertItemFromServer(res.body);
    //    return res.clone({ body });
    //}

    private convertArrayResponse(res: HttpResponse<Nema.Crew.Model.Workplace[]>): HttpResponse<Nema.Crew.Model.Workplace[]> {
        const jsonResponse: Nema.Crew.Model.Workplace[] = res.body;
        const body: Nema.Crew.Model.Workplace[] = [];
        for (let i = 0; i < jsonResponse.length; i++) {
            body.push(this.convertItemFromServer(jsonResponse[i]));
        }

        return res.clone({ body });
    }

    private convertItemFromServer(workplace: Nema.Crew.Model.Workplace): Nema.Crew.Model.Workplace{
        const copy: Nema.Crew.Model.Workplace = Object.assign({}, workplace);
        return copy;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/services/workplace.service.ts